/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from '../../http/requests/auth/jwt/index.js'
import router from '@/router'

export default {
  // JWT
  // loginJWT ({ commit }, payload) {
  login ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      jwt.login(payload.userDetails.email, payload.userDetails.password)
        .then(response => {
          const usuario = JSON.parse(response.data.userData)
          // If there's user data in response
          if (usuario && usuario.activo === true) {
            // Set accessToken
            sessionStorage.setItem('accessToken', response.data.accessToken)
            sessionStorage.setItem('refreshToken', response.data.refresh_token)

            // Update user details
            commit('UPDATE_USER_INFO', usuario, {root: true})

            // Set bearer token in axios
            commit('SET_BEARER', response.data.accessToken)
            
            // Se chamamos desde cambiar contrasinal non se redirixe a 'inicio'
            payload.userDetails.cambioContrasinal ? null : router.push({ name: 'inicio' })

            resolve(response)
          } else {
            reject({message: 'No existe ningún usuario con estas credenciales de acceso.'})
          }

        })
        .catch(error => { 
          const e = JSON.stringify(error.message)

          if (e.substring(e.length - 4, e.length - 1) === '401') {
            if (payload.userDetails.cambioContrasinal) {
              error.message = 'La contraseña actual no es correcta. No se ha podido realizar el cambio de contraseña.'
            } else {
              error.message = 'No existe ningún usuario con estas credenciales de acceso.'
            }
          } else if (e.substring(1, e.length - 1) === 'Network Error') {
            error.message = 'Error de conexión con el servidor.'
          }
          reject(error) 
        })
    })
  },
  fetchAccessToken () {
    return new Promise((resolve) => {
      jwt.refreshToken().then(response => { 
        router.push({ name: 'inicio' })
        resolve(response) 
      })
    })
  },
  setRefreshAccesToken ({ commit }, payload) {
    commit('SET_BEARER', payload)
  }
}
